import React from "react";
import Layout from "../components/base/Layout";
import SEO from "../components/base/SEO";
import ReceiptMakerIndex from "../components/pages/receipt-maker/index";

const IndexPage = () => (
  <Layout>
    <SEO
      title="The best free receipt maker on the web"
      desc="With receipt maker you can create a receipt for your business in minutes."
    />
    <ReceiptMakerIndex />
  </Layout>
);

export default IndexPage;
